import { createContext, useContext } from 'react';
import { defStore } from '@/react/store/reducer';
const defContext = [defStore, () => ({})];
export const CartContext = createContext(defContext);
export const useCartContext = () => useContext(CartContext);
